export function getView(is_enabled, tab) {
  return is_enabled && tab === 'ledger'
}
